import {
  AttendeePaymentMethod,
  PAYMENT_METHOD_OPTIONS,
} from '../../services/courseSessionsService';

const defaultClassName =
  'w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 transition focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-400';

type PaymentMethodSelectProps = {
  value: AttendeePaymentMethod;
  onChange: (value: AttendeePaymentMethod) => void;
  className?: string;
  disabled?: boolean;
  id?: string;
};

export function PaymentMethodSelect({
  value,
  onChange,
  className = defaultClassName,
  disabled = false,
  id,
}: PaymentMethodSelectProps) {
  return (
    <select
      id={id}
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value as AttendeePaymentMethod)}
      disabled={disabled}
    >
      {PAYMENT_METHOD_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
